import { lazy } from 'react';

import RecommenderRedirection from 'modules/landingPages/presentation/pages/RecommenderRedirection';
import type { TRoute } from 'shared/presentation/modules/definitions';

const Benefit = lazy(
  () => import('modules/landingPages/presentation/pages/Benefit'),
);
const EightyOff = lazy(
  () => import('modules/landingPages/presentation/pages/EightyOff'),
);
const EightyOffTiktok = lazy(
  () => import('modules/landingPages/presentation/pages/EightyOffTiktok'),
);
const Coupon100 = lazy(
  () => import('modules/landingPages/presentation/pages/Coupon100'),
);
const Coupon100TikTok = lazy(
  () => import('modules/landingPages/presentation/pages/Coupon100TikTok'),
);
const FluencyLP = lazy(
  () => import('modules/landingPages/presentation/pages/FluencyLP'),
);
const FreeAxillaCombo = lazy(
  () => import('modules/landingPages/presentation/pages/FreeAxillaCombo'),
);
const FullAxillas = lazy(
  () => import('modules/landingPages/presentation/pages/FullAxillas'),
);
const LeadViaRecommendation = lazy(
  () => import('modules/landingPages/presentation/pages/LeadViaRecommendation'),
);
const LightningOffer = lazy(
  () => import('modules/landingPages/presentation/pages/LightningOffer'),
);
const MothersDay = lazy(
  () => import('modules/landingPages/presentation/pages/MothersDay'),
);
const RecommenderIdentification = lazy(
  () =>
    import('modules/landingPages/presentation/pages/RecommenderIdentification'),
);
const ThreeSessionsGift = lazy(
  () => import('modules/landingPages/presentation/pages/ThreeSessionsGift'),
);
const TotemQRCodeRecommendation = lazy(
  () =>
    import('modules/landingPages/presentation/pages/TotemQRCodeRecommendation'),
);

const routes: TRoute[] = [
  {
    type: 'route',
    path: '/depilacao-a-laser-promocao',
    component: LightningOffer,
    disabledTenancies: ['es', 'es-CR', 'es-UY'],
  },
  {
    type: 'route',
    path: '/voce-ganhou',
    component: ThreeSessionsGift,
    disabledTenancies: ['es', 'es-CR', 'es-UY'],
  },
  {
    type: 'route',
    path: '/has-ganado-3-sesiones',
    component: ThreeSessionsGift,
    disabledTenancies: ['es', 'es-UY', 'pt'],
  },
  {
    type: 'route',
    path: '/lp-fluency',
    component: FluencyLP,
    disabledTenancies: ['es', 'es-CR', 'es-UY'],
  },
  {
    type: 'route',
    path: '/indicacao/:hash',
    component: LeadViaRecommendation,
    disabledTenancies: ['es', 'es-CR', 'es-UY'],
  },
  {
    type: 'route',
    path: '/indicacao-mae',
    component: MothersDay,
    disabledTenancies: ['es', 'es-CR', 'es-UY'],
  },
  {
    type: 'route',
    path: '/beneficio-indicacao',
    component: Benefit,
    disabledTenancies: ['es-CR', 'es-UY'],
  },
  {
    type: 'route',
    path: '/indicador',
    component: RecommenderIdentification,
    disabledTenancies: ['es-CR', 'es-UY'],
  },
  {
    type: 'route',
    path: '/compartilhe-e-ganhe',
    component: RecommenderRedirection,
  },
  {
    type: 'route',
    path: '/indique-e-ganhe',
    component: RecommenderRedirection,
  },
  {
    type: 'route',
    path: '/sorteiototem',
    component: TotemQRCodeRecommendation,
    disabledTenancies: ['es', 'es-CR', 'es-UY'],
  },
  {
    type: 'route',
    path: '/80-off',
    component: EightyOff,
    disabledTenancies: ['es', 'es-CR', 'es-UY'],
  },
  {
    type: 'route',
    path: '/cupom-100',
    component: Coupon100,
    disabledTenancies: ['es', 'es-CR', 'es-UY'],
  },
  {
    type: 'route',
    path: '/cupom-100-tt',
    component: Coupon100TikTok,
    disabledTenancies: ['es', 'es-CR', 'es-UY'],
  },
  {
    type: 'route',
    path: '/80-off-TT',
    component: EightyOffTiktok,
    disabledTenancies: ['es', 'es-CR', 'es-UY'],
  },
  {
    type: 'route',
    path: '/combo-com-axilas-gratis',
    component: FreeAxillaCombo,
    disabledTenancies: ['es', 'es-CR', 'es-UY'],
  },
  {
    type: 'route',
    path: '/axilas-completas',
    component: FullAxillas,
    disabledTenancies: ['es', 'es-CR', 'es-UY'],
  },
];

export default routes;
